import { Expose } from 'class-transformer';
import { IsString } from 'class-validator';
import { Section } from '../../../entities';

export default class CreateSectionInput implements Omit<Section, 'id' | 'created' | 'updated'> {
  @IsString()
  readonly label: string;

  @Expose({ name: 'condominium_id' })
  @IsString()
  readonly condominiumId: string;

  constructor(init?: CreateSectionInput) {
    this.label = init?.label!;
    this.condominiumId = init?.condominiumId!;
  }
}
